// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"72dc6402","303":"72dc6402","688":"72dc6402","922":"72dc6402"}[chunkId] + ".chunk.css";
};